<template>
  <div name="sidebar">
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <!-- Soonnet Logo -->
      <router-link :to="{ name: 'Index' }" class="brand-link clearfix">
        <img
          src="../../assets/backImage/soonnet-logo.svg"
          alt="Soonnet Logo"
          class="brand-image"
          style="opacity: 0.9"
        />
      </router-link>
      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li class="nav-header">網站內容</li>
            <li v-for="item in menuDataList2" class="nav-item has-treeview">
              <a
                href="javascript:"
                class="nav-link"
                v-if="item.menuDto && item.menuDto.length > 0"
                @click="clickMenu = item.sgL_Name"
              >
                <i class="nav-icon fas" :class="item.sgL_Ico"></i>
                <p>{{ item.sgL_Name }}<i class="right fas fa-caret-up"></i></p>
              </a>
              <router-link
                v-else
                class="nav-link"
                exact
                v-bind:to="{ name: item.sgL_Url }"
                ><i class="nav-icon fas" :class="item.sgL_Ico"></i>
                <p>{{ item.sgL_Name }}</p>
              </router-link>
              <ul
                class="nav nav-treeview"
                v-if="item.menuDto && item.menuDto.length > 0"
                :class="{ show: clickMenu === item.sgL_Name }"
              >
                <li class="nav-item" v-for="abc in item.menuDto">
                  <router-link
                    class="nav-link"
                    exact
                    v-bind:to="{ name: abc.sgL_Url }"
                    :class="{
                      'active router-link-active sd':
                        $route.name === abc.sgL_Url,
                    }"
                  >
                    <p>{{ abc.sgL_Name }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li v-for="item in menuDataList" class="nav-item has-treeview">
              <a
                href="javascript:"
                class="nav-link"
                v-if="item.childList && item.childList.length > 0"
                @click="clickMenu = item.name"
              >
                <i class="nav-icon fas" :class="item.icon"></i>
                <p>{{ item.name }}<i class="right fas fa-caret-up"></i></p>
              </a>
              <router-link
                v-else
                class="nav-link"
                exact
                v-bind:to="{ name: item.url }"
                ><i class="nav-icon fas" :class="item.icon"></i>
                <p>{{ item.name }}</p>
              </router-link>
              <ul
                class="nav nav-treeview"
                v-if="item.childList && item.childList.length > 0"
                :class="{ show: clickMenu === item.name }"
              >
                <li class="nav-item" v-for="abc in item.childList">
                  <router-link
                    class="nav-link"
                    exact
                    v-bind:to="{ name: abc.url }"
                    :class="{
                      'active router-link-active sd': $route.name === abc.url,
                    }"
                  >
                    <p>{{ abc.name }}</p>
                  </router-link>
                </li>
              </ul>
            </li> -->
          </ul>
        </nav>
        <!-- /.Sidebar Menu -->
      </div>
      <!-- /.Sidebar -->
    </aside>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  data() {
    return {
      clickMenu: "",
      menuDataList2: [],
      menuDataList: [
        {
          icon: "fa-chart-bar",
          name: "數據分析",
          url: "adminIndex",
        },
        {
          icon: "fa-star",
          name: "首頁設定",
          childList: [
            {
              url: "banner",
              name: "廣告列表",
            },
          ],
        },
        {
          icon: "fa-images",
          name: "相簿",
          childList: [
            {
              url: "AdminalbumList",
              name: "相簿列表",
            },
            {
              url: "AdminCollection",
              name: "相簿合集列表",
            },
            {
              url: "albumCategory",
              name: "相簿分類",
            },
          ],
        },
        {
          icon: "fa-play-circle",
          name: "影音",
          childList: [
            {
              url: "TVList",
              name: "Soonnet TV 列表",
            },
            {
              url: "VideoList",
              name: "一般影片列表",
            },
            {
              url: "FeatureList",
              name: "精選影音",
            },
            {
              url: "AdminProgramList",
              name: "節目列表",
            },
            {
              url: "programType",
              name: "節目類型",
            },
            {
              url: "VideoType",
              name: "影片分類",
            },
          ],
        },
        {
          icon: "fa-file-video",
          name: "用戶短視頻",
          childList: [
            {
              url: "adminVideoList",
              name: "短視頻列表",
            },
          ],
        },
        {
          icon: "fa-calendar",
          name: "活動",
          childList: [
            {
              url: "EventList",
              name: "活動列表",
            },
            {
              url: "EventType",
              name: "活動類型",
            },
            {
              url: "EventCity",
              name: "活動地區",
            },
            {
              url: "EventArea",
              name: "活動縣市",
            },
            {
              url: "EventStatus",
              name: "報名狀態",
            },
            {
              url: "EventRemark",
              name: "活動標籤",
            },
          ],
        },
        {
          icon: "fa-fire",
          name: "話題",
          childList: [
            {
              url: "TopicList",
              name: "文章列表",
            },
            {
              url: "TopicRecommend",
              name: "編輯推薦",
            },
            {
              url: "TopicTypeList",
              name: "文章類型",
            },
            {
              url: "TopicReprint",
              name: "轉載來源",
            },
          ],
        },
        {
          icon: "fa-list",
          name: "頁腳",
          childList: [
            {
              url: "footParent",
              name: "頁腳母層管理",
            },
            {
              url: "footChild",
              name: "頁腳子層管理",
            },
            {
              url: "footPage",
              name: "頁面管理",
            },
          ],
        },
        {
          icon: "fa-user",
          name: "用戶",
          childList: [
            {
              url: "userList",
              name: "用戶列表",
            },
            {
              url: "roleList",
              name: "角色列表",
            },
          ],
        },
        {
          icon: "fa-user",
          name: "社交動態",
          childList: [
            {
              url: "adminSocia",
              name: "動態列表",
            },
            {
              url: "adminSociaGroup",
              name: "群組列表",
            },
            {
              url: "adminSociaCloseGroup",
              name: "已關閉群組列表",
            },
          ],
        },
        {
          icon: "fa-comment-dots",
          name: "留言",
          childList: [
            {
              url: "comments",
              name: "留言列表",
            },
          ],
        },
        {
          icon: "fa-ad",
          name: "廣告",
          childList: [
            {
              url: "AdVertiserList",
              name: "廣告商管理",
            },
          ],
        },
        {
          icon: "fa-history",
          name: "操作日誌",
          childList: [
            {
              url: "adminLog",
              name: "管理人員操作日誌",
            },
            {
              url: "userLog",
              name: "用戶操作日誌",
            },
          ],
        },
        {
          icon: "fa-ban",
          name: "檢舉內容",
          url: "adminReport",
        },
      ],
    };
  },
  created() {
    this.getMenu();
    // console.log("頁面重載了");
  },
  methods: {
    getMenu() {
      this.$api.permissionApi.getMenu().then((res) => {
        this.menuDataList2 = res.data.result;
      });
    },
    clickMent(n) {
      for (var i = 1; i <= 15; i++) {
        if (i === n) {
          continue;
        }
        this["show" + i] = false;
      }
      this["show" + n] = !this["show" + n];
    },
  },
};
</script>

<style scoped>
.show {
  display: block;
}
.sd {
  background-color: #26ad5e !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminManage/sidebar.vue